const defaultFlags = {
  newComponent: true,
}

export const featureFlags = {
  ...defaultFlags,
}
